import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthenticationsService } from '../../modules/authentications/authentications.service';
import { RouteUtils } from '../../shared/utils/route/route.util';

@Injectable({
	providedIn: 'root',
})
export class AuthGuardService {
	constructor(
		private readonly authenticationsService: AuthenticationsService,
		private readonly router: Router,
	) {}

	canActivateChild(): Observable<UrlTree | boolean> | UrlTree | boolean {
		const loginPath: string = RouteUtils.paths.auth.login;
		const token =
			localStorage.getItem('token') || sessionStorage.getItem('token');

		if (!token) {
			return this.router.parseUrl(loginPath);
		} else {
			return this.authenticationsService.refreshToken().pipe(
				map((response) => {
					if (response.access_token) {
						this.authenticationsService.setToken(
							response.access_token,
							response.refresh_token,
							response,
						);

						return true;
					} else {
						return this.router.parseUrl(loginPath);
					}
				}),
			);
		}
	}
}
